module.exports = __webpack_public_path__ + "static/media/handOpenGrid.ee4a51f4.png";